import React from "react";
import styleLogin from "./login.module.css";
import logo from "../../../assets/img/logo-1.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import InputElement from "../../form/InputElement";
import { useState, useEffect } from "react";
import UseAuth from "../../../hooks/UseAuth";
import { post } from "../../../adapters/xhr/api";

import {
  login,
  verifyMobileSendOtp,
  checkVerifications,
  validateEmail,
} from "../../../adapters/apis/auth/auth";
import Cookies from "js-cookie";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import Footer from "../../../layouts/footer/Footer";
import { ValidateLogin } from "../../../validations/ValidateLogin";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";

const Login = ({ response }) => {
  const { setAuth } = UseAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const success = location.state?.success || false;
  const [showSuccess, setShowSuccess] = useState(success);
  const [submissionError, setSubmissionError] = useState(null);
  const [isResendingOTP, setIsResendingOTP] = useState(false);
  const [isResendingEmail, setIsResendingEmail] = useState(false);
  const [pendingMobile, setPendingMobile] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [pendingCountryCode, setPendingCountryCode] = useState(null);

  // Grouped Login Data
  const [loginData, setLoginData] = useState({
    mobile: "",
    name: "",
    password: "",
    dial_code: "",
    country_code: "",
    email: "",
  });

  // Grouped Error Messages
  const [loginErrors, setLoginErrors] = useState({
    mobile: "",
    name: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const [loginMethod, setLoginMethod] = useState("mobile"); // "national_id" | "mobile"

  const firstFieldProps =
    loginMethod === "mobile"
      ? {
          name: "mobile",
          labelText: "رقم الهاتف المحمول",
          placeholder: "أدخل رقم الهاتف المحمول",
          maxLength: 11,
          allowedPattern: /^0?$|^0(1(0|1|2|5)?)?$|^0(10|11|12|15)\d{0,8}$/,
        }
      : {
          name: "name",
          labelText: "الرقم القومى / رقم جواز السفر",
          placeholder: "أدخل الرقم القومى أو رقم جواز السفر",
          maxLength: 24,
          allowedPattern: /^[A-Za-z0-9\/\-]+$/,
        };

  const handleSwitchMethod = (method) => {
    setLoginMethod(method);
    setSubmissionError(null);
    setPendingCountryCode(null);
    setLoginData({
      mobile: "",
      name: "",
      password: "",
    });

    setLoginErrors({
      mobile: "",
      name: "",
      password: "",
    });
  };
  function handleInputChange(parent, component, key, value) {
    setLoginErrors({
      mobile: "",
      name: "",
      password: "",
    });
    //validateLoginFields(setError, key, value, loginMethod)
    setLoginData((prev) => ({ ...prev, [key]: value }));
  }

  function setError(key, value) {
    setLoginErrors((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const validatePhoneBeforeSubmit = () => {
    const value = loginData?.mobile;
    const dialCode = loginData?.dial_code;
    const countryCode = loginData?.country_code;
    const nationalNumber = value?.replace(dialCode, "")?.replace(/\D/g, "");
    if (
      value === dialCode ||
      value === "" ||
      value === null ||
      value === undefined
    ) {
      setPhoneError("يجب ادخال رقم الهاتف المحمول");
      return false;
    }

    // Egypt-specific rules
    if (countryCode === "eg") {
      const regex = /^(?:0?)(10|11|12|15)\d{8}$/;
      if (!regex.test(nationalNumber)) {
        setPhoneError(
          "رقم الهاتف المدخل يجب أن يكون رقم هاتف محمول مصريًا صالحًا. يُرجى اختيار مفتاح الدولة (+20) وإدخال رقم هاتف مصري صحيح",
        );
        return false;
      }
    }

    // General validation for other countries
    if (!isValidPhoneNumber("+" + value)) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    // Length rule (≤15 digits excluding country code)
    if (nationalNumber?.length < 6 || nationalNumber?.length > 15) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    setPhoneError(null);
    return true;
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    setSubmissionError(null);

    const isPhoneValid =
      loginMethod === "mobile" ? validatePhoneBeforeSubmit() : true;

    if (ValidateLogin(setError, loginData, loginMethod) && isPhoneValid) {
      login(loginMethod, loginData.mobile, loginData.name, loginData.password)
        .then((response) => {
          // If Loggedin
          const accessToken = response?.data?.access_token;
          const refreshToken = response?.data?.refresh_token;
          const full_name = response?.data?.first_name;
          const phone_verified = response?.data?.phone_verified;
          const ocr_verified = response?.data?.ocr_verified;
          // set  data in local storage
          Cookies.set("auth-token", accessToken);
          Cookies.set("refresh-token", refreshToken);
          Cookies.set("user-name", full_name);
          // Cookies.set("phone_verified", phone_verified);
          // Cookies.set("ocr_verified", ocr_verified);

          if (response?.data?.idle_timeout_minutes) {
            Cookies.set(
              "idle-timeout-mins",
              String(response.data.idle_timeout_minutes),
              { sameSite: "strict", secure: true },
            );
          }

          //for support-page
          localStorage.setItem("user-full-name", full_name);

          const isAuth = true;
          // set context
          // setAuth({ full_name, accessToken, isAuth , phone_verified: response?.data?.phone_verified, ocr_verified: response?.data?.ocr_verified });
          setAuth({
            full_name,
            accessToken,
            isAuth,
            phone_verified,
            ocr_verified,
          });

          if (!response?.data?.fully_verified) {
            navigate("/DisabledHome", { replace: true });
            return;
          }

          navigate("/", { replace: true });
          // redirect to next page
        })
        .catch((err) => {
          setIsLoading(false);
          const responseData = err?.response?.data;
          if (err?.response?.status === 422 || err?.response?.status === 401) {
            if (err?.response?.data?.errors) {
              Object.keys(responseData?.errors).forEach((key) => {
                setError(key, responseData?.errors[key][0]);
              });
            } else if (responseData?.data?.is_not_active) {
              const mobile = responseData?.data?.mobile;
              setLoginData((prev) => ({
                ...prev,
                mobile: responseData?.data?.mobile,
                country_code: responseData?.data?.country_code,
                email: responseData?.data?.email,
              }));

              sessionStorage.setItem("email", responseData?.data?.email ?? "");
              setSubmissionError(responseData?.data?.message);
              setPendingCountryCode(responseData?.data?.country_code);
              setPendingMobile(mobile);
              /*  setSubmissionError(
                <span>
                  {responseData?.data?.message} .
                    <button
                      type="button"
                      onClick={() => handleResendOTP(mobile, loginData?.password)}
                      className={
                        isResendingOTP
                          ? `${styleLogin.resendLink} ${styleLogin.resendLinkDisabled}`
                          : styleLogin.resendLink
                      }
                    >
                      {isResendingOTP ? "جاري الإرسال..." : "إعادة إرسال رسالة التفعيل"}
                    </button>

                  {/* <button
                    type="button"
                    disabled={isResendingOTP}
                    onClick={() => handleResendOTP(mobile, loginData?.password)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "rgb(13 110 253)",
                      textDecoration: "underline",
                      cursor: "pointer",
                      padding: 0,
                    }}
                    disabled={isLoading}
                  >
                    إعادة إرسال رسالة التفعيل
                  </button> }
                </span>,
              ); */
            } else {
              const errorMsg = responseData?.data?.message;
              setSubmissionError(errorMsg);
            }
          } else {
            setSubmissionError("حدث خطأ ما، يرجى المحاولة مرة أخرى");
          }
        });
    } else {
      setIsLoading(false);
    }
  };

  const handleResendEmailVerification = async (email) => {
    if (isResendingEmail) return;
    setIsResendingEmail(true);
    try {
      validateEmail({ email: email })
        .then((res) => {
          navigate(`/mail-verify?email=${email}`);
        })
        .catch((error) => {
          setSubmissionError(
            error?.response?.data?.message || "حدث خطأ أثناء إرسال البريد",
          );
        });
    } catch (err) {
      setSubmissionError("حدث خطأ أثناء إرسال البريد");
    } finally {
      setIsResendingEmail(false);
    }
  };

  const handleResendOTP = async (mobile, password) => {
    if (isResendingOTP) return;

    setIsResendingOTP(true);
    //setIsLoading(true);

    try {
      const response = await verifyMobileSendOtp({
        mobile,
        context: "register",
      });

      const result = response?.data;

      if (result.code === 0) {
        const request_code = result.data.request_code;

        sessionStorage.setItem("context", result.data.context);
        sessionStorage.setItem("mobile", result.data.mobile);
        sessionStorage.setItem("request_code", request_code);
        sessionStorage.setItem("user_id", result.data.user_id);
        sessionStorage.setItem("sms_otp_expire", result.data.sms_otp_expire);
        sessionStorage.setItem("pass", password);

        navigate(`/confirm-otp?token=${encodeURIComponent(request_code)}`, {
          state: { request_code },
        });
      }
    } catch (err) {
      setSubmissionError(
        err?.response?.data?.message || "حدث خطأ أثناء إرسال الرمز",
      );
    } finally {
      setIsResendingOTP(false);
    }
  };

  /* const handleResendOTP = async (mobile, password) => {
    if (isResendingOTP) return; 
    setIsResendingOTP(true);
    try {
      //setIsLoading(true);
      // Replace with your actual OTP API call
      verifyMobileSendOtp({ mobile: mobile, context: "register" })
        .then((response) => {
          const result = response?.data;
          if (result.code === 0) {
            const request_code = result.data.request_code;
            sessionStorage.setItem("context", result.data.context);
            sessionStorage.setItem("mobile", result.data.mobile);
            sessionStorage.setItem("request_code", request_code);
            sessionStorage.setItem("user_id", result.data.user_id);
            sessionStorage.setItem(
              "sms_otp_expire",
              result.data.sms_otp_expire,
            );
            sessionStorage.setItem("pass", password);
            const params = new URLSearchParams({
              token: response?.data?.data?.request_code,
              context: response?.data?.data?.context,
            });
            setIsLoading(false);
            navigate(
              `/confirm-otp?${params.toString()}`,
            );
          }
        })
        .catch((err) => {
          const errorMsg = err?.response?.data.message;
          setSubmissionError(errorMsg);
          setIsLoading(false);
        });
    } catch (err) {
      setSubmissionError("حدث خطأ أثناء إرسال الرمز");
      setIsLoading(false);
      setIsResendingOTP(false);
    }
  }; */

  // // create account successfuly msg
  // useEffect(() => {
  //   if (success) {
  //     const t = setTimeout(() => {
  //       setShowSuccess(false);
  //       navigate(location.pathname, { replace: true, state: {} });
  //     }, 5000); // 5000ms = 5 ثواني
  //     return () => clearTimeout(t);
  //   }
  // }, [success, navigate, location.pathname]);

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section className={styleLogin["login-section"]}>
          <div className="container">
            <div className="row justify-content-center pt-5">
              <div className="col-lg-5 col-md-8">
                <div className={`card ${styleLogin["card"]}`}>
                  <div className="text-center mt-5">
                    <Link to="/">
                      <img src={logo} alt="..." />
                    </Link>
                  </div>

                  {response?.message && (
                    <div
                      className={`${styleLogin["card-body"]} card-body mt-4`}
                    >
                      <div
                        className={`alert ${response.class} text-center`}
                        role="alert"
                      >
                        {response.message}
                      </div>
                    </div>
                  )}

                  {/* {submissionError && (
                    <div
                      className={`${styleLogin["card-body"]} card-body mt-5`}
                    >
                      <div className="alert alert-danger  mt-3" role="alert">
                        {submissionError}
                      </div>
                    </div>
                  )} */}
                  {submissionError && (
                    <div className="alert alert-danger mt-3">
                      <span>{submissionError}.</span>{" "}
                      {pendingMobile && (
                        <>
                          {(pendingCountryCode ?? loginData?.country_code) ===
                          "eg" ? (
                            <button
                              type="button"
                              onClick={() =>
                                handleResendOTP(
                                  pendingMobile,
                                  loginData?.password,
                                )
                              }
                              className={
                                isResendingOTP
                                  ? `${styleLogin.resendLink} ${styleLogin.resendLinkDisabled}`
                                  : styleLogin.resendLink
                              }
                            >
                              إعادة إرسال رسالة التفعيل
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={() =>
                                handleResendEmailVerification(loginData?.email)
                              }
                              className={
                                isResendingEmail
                                  ? `${styleLogin.resendLink} ${styleLogin.resendLinkDisabled}`
                                  : styleLogin.resendLink
                              }
                            >
                              إعادة إرسال بريد التفعيل للبريد الإلكتروني
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  )}

                  <div
                    className={`card-body mt-4 ${styleLogin["switcher-wrapper"]}`}
                  >
                    <div
                      className={styleLogin["login-switcher"]}
                      role="tablist"
                      aria-label="طريقة الدخول"
                    >
                      <button
                        type="button"
                        className={`${styleLogin["switcher-btn"]} ${loginMethod === "mobile" ? styleLogin["active"] : ""}`}
                        onClick={() => handleSwitchMethod("mobile")}
                        aria-pressed={loginMethod === "mobile"}
                      >
                        الهاتف المحمول
                      </button>
                      <button
                        type="button"
                        className={`${styleLogin["switcher-btn"]} ${loginMethod === "national_id" ? styleLogin["active"] : ""}`}
                        onClick={() => handleSwitchMethod("national_id")}
                        aria-pressed={loginMethod === "national_id"}
                      >
                        الرقم القومي / رقم جواز السفر
                      </button>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit} id="login_form">
                    <div
                      className={`${styleLogin["card-body"]} card-body mt-5`}
                    >
                      {loginMethod === "mobile" ? (
                        <div className="mb-4">
                          <label
                            htmlFor="mobile"
                            className={`required ${styleLogin["form-label"]} form-label`}
                          >
                            رقم الهاتف المحمول
                          </label>

                          <PhoneInput
                            country={"eg"} // default Egypt
                            preferredCountries={[
                              "eg",
                              "sa",
                              "ae",
                              "jo",
                              "kw",
                              "qa",
                              "bh",
                              "om",
                              "ma",
                            ]}
                            value={loginData.mobile}
                            onChange={(value, country) => {
                              // When the country changes, reset to just the dial code
                              if (
                                country?.countryCode !== loginData?.country_code
                              ) {
                                value = country?.dialCode;
                              }

                              const nationalNumber = value
                                ?.replace(country?.dialCode, "")
                                ?.replace(/\D/g, "");

                              // ✅ Egypt-specific normalization: remove extra leading 0
                              if (
                                country?.countryCode === "eg" &&
                                nationalNumber?.startsWith("0")
                              ) {
                                value =
                                  country?.dialCode + nationalNumber?.slice(1);
                              }

                              // ✅ Length validation, but don’t wipe the value
                              if (
                                (nationalNumber?.length < 6 ||
                                  nationalNumber?.length > 15) &&
                                value !== country?.dialCode
                              ) {
                                setPhoneError(
                                  "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
                                );
                                // keep the current value instead of returning
                                handleInputChange("", "", "mobile", value);
                              } else {
                                setPhoneError(null);
                                handleInputChange("", "", "mobile", value);
                              }

                              handleInputChange("", "", "mobile", value);
                              handleInputChange(
                                "",
                                "",
                                "country_code",
                                country?.countryCode,
                              );
                              handleInputChange(
                                "",
                                "",
                                "dial_code",
                                country?.dialCode,
                              );
                            }}
                            inputProps={{
                              name: "mobile",
                              id: "mobile",
                              required: true,
                              className: `phone-control form-control`,
                            }}
                            inputProps={{
                              name: "mobile",
                              id: "mobile",
                              required: true,
                              className: `phone-control form-control`,
                              placeholder: "",
                            }}
                            containerClass="w-100"
                            inputClass="w-100"
                            enableAreaCodes={false}
                            enableSearch={true}
                            countryCodeEditable={false}
                          />

                          {(phoneError || loginErrors.mobile) && (
                            <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                              {phoneError || loginErrors.mobile}
                            </p>
                          )}
                        </div>
                      ) : (
                        <InputElement
                          key={loginMethod}
                          name="name"
                          mb4="mb-4"
                          labelHtmlFor="name"
                          labelClassName={` required ${styleLogin["form-label"]} form-label`}
                          labelText="الرقم القومى / رقم جواز السفر"
                          inputType="text"
                          inputClassName={`${styleLogin["form-control"]} form-control`}
                          inputID="name_input"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={loginData.name}
                          pText={loginErrors.name}
                          onChange={handleInputChange}
                          maxLength={24}
                          allowedPattern={/^[A-Za-z0-9\/\-]+$/}
                        />
                      )}

                      <InputElement
                        name="password"
                        mb4="mb-4 parent-password"
                        labelHtmlFor="password"
                        labelClassName={` required ${styleLogin["form-label"]} form-label`}
                        labelText="كلمة المرور"
                        inputType="password"
                        inputClassName={`${styleLogin["form-control"]} form-control`}
                        inputID="password"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        value={loginData.password}
                        onChange={handleInputChange}
                        pText={loginErrors.password}
                        allowedPattern={/^[^\s]+$/}
                        maxLength={255}
                      />
                      <div
                        className={`${styleLogin["forget-password"]} text-start`}
                      >
                        <Link to="/forget-password" id="forget_password_id">
                          هل نسيت كلمة المرور ؟
                        </Link>
                      </div>
                      <div
                        className={`${styleLogin["login-btn"]} text-center mt-4`}
                      >
                        <button
                          type="submit"
                          className={`${styleLogin["btn-login"]} mb-4 d-block`}
                          id="login_button"
                        >
                          تسجيل الدخول
                        </button>
                        <Link
                          to="/register"
                          id="signUp_button"
                          className={`${styleLogin["btn-register"]} d-block mb-4`}
                        >
                          إنشاء حساب جديد
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
};

export default Login;
